// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"724":"4b42f979","744":"f7ba4d7d"}[chunkId] + ".chunk.css";
};